import React from "react"
import P from "../../../../components/typography/P"
import CalendarGraphic from "../../../../images/platform/offers/calendar-icon.svg"
import PaymentBillingImage from "../../../../components/staticQuery/home/PaymentBillingImage"

const DescriptionText = () => (
  <>
    <P>
      Collecting payments, managing subscriptions, and capturing donations
      online is now a breeze with MindMe’s integrated merchant processing
      solution. Easily set up items to sell and market them using text and email
      campaigns, QR codes, landing pages, branded checkout pages, or directly on
      your website.
    </P>
    <P>
      Designed for small businesses and nonprofits, our platform simplifies
      digital payments and subscription management—so you can focus on growing
      your revenue.
    </P>
  </>
)

const paymentAndBillingData = {
  titleIcon: CalendarGraphic,
  title:
    "Streamline Payment Collection & Boost Revenue with Integrated Merchant Processing and Billing",
  description: <DescriptionText />,
  graphic: <PaymentBillingImage />,
  // imageLeft: false,
  textLong: false,
  benefits: [
    {
      benefitName: "Payment, subscription & donation management",
    },
    {
      benefitName: "Quick approval and next day funding",
    },
    { benefitName: "Integrated with MindMe CRM & Marketing" },
    { benefitName: "Real-time reporting and analytics" },
  ],
}

export default paymentAndBillingData
